<template>
    <SrcInputLabel v-if="label" :for="TextId">
      {{ label }}
    </SrcInputLabel>  
    <SrcTextarea
      :id="TextId"
      :class="{'mt-1' : label }"
      v-bind="$attrs"
    >
      <p 
      :class="{ 'text-base' : smalltxt }"
      v-html="text"></p>
    </SrcTextarea>
  </template>
 <script>
 import SrcTextarea from '../sources/SrcTextarea.vue'
 import SrcInputLabel from '../sources/SrcInputLabel.vue'
 
 export default {
   components: {
    SrcTextarea,
    SrcInputLabel
   },
   props: {
      text: {
       type: String,
       default: ''
      },
      label: {
        type: String,
        default: ''
      },
      smalltxt: {
        type: Boolean,
        default: false
      },
   },
   data() {
     return {
       TextId: `Text-${Math.random().toString(36).substring(7)}`
     };
   },
 };
 </script>